// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"ColoredScrollbar_scrollbar__26_cg"};